import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SikoPageSlotModule } from '@siko/features/shared-components/page-slot/page-slot.module';

@Component({
   selector: 'app-configuration-template',
   imports: [SikoPageSlotModule],
   templateUrl: './configuration-template.component.html',
   styleUrls: ['./configuration-template.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SikoConfigurationTemplateComponent {}
